import React, { useRef, useEffect, useState } from 'react';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { isLogin, getPrivileges } from '../../../functions/Auth';

const LaneGeometry = props => {
  const [moreOpt, setMoreOpt] = useState(false);

  useEffect(() => {
    
  }, [])
  

  const handleClickAway = () => {
    setMoreOpt(false);
  }

  const handleShowLane = () => {
    setMoreOpt(false);
    props.setReadOnlyOpt(false);
    props.setShowLaneConfig(true);
  }

  return (
    <Card className={'details-main-info signal-planning-details'} style={{position: 'relative', alignItems: 'center'}}>
      <div className='lane-status'>
        <div className={props.stationData['FK_lane_config_id'] ? 'capacity-ratio emerald-txt' : 'capacity-ratio red-txt'}>
            <label className='indicator'></label>
            <label>{props.stationData['FK_lane_config_id'] ? "Lane geometry set" : "No lane geometry set"}</label>
        </div>
        {
          (getPrivileges().length !== 0 && getPrivileges().includes(1)) &&
          <img src={require('../../../assets/icons/lane_config/vertical_dots.svg')} onClick={() => setMoreOpt(!moreOpt)} />
        }
      </div>
      {
        props.stationData['FK_lane_config_id'] ? 
        <>
        <div className='sb-approach' style={{marginBottom: '-12px'}}>
          <span>{props.approaches.sb_approach}</span>
        </div> 
        <div style={{width:'320px',position:'relative',display: "flex", "flex-direction": "column"}}>
          <img src={require("../../../assets/images/lane_geometry.svg")} style={{ width: "320px"}} />
          <div className='lane-details' style={{ position: 'absolute', top: '10px', width: '100%', left: '10px' }}>
            <div>
              <div className='corner-top-left'>
                {
                  props.laneGeometryData.control_type === 'Signal' ?
                    <img src={require('../../../assets/icons/lane_config/signal.svg')} />
                    :
                    props.laneGeometryData.control_type === 'AWSC' || (props.laneGeometryData.control_type === 'TWSC' && props.laneGeometryData.stop_controlled === 'NS') ?
                      <img src={require('../../../assets/icons/lane_config/stop_sign.svg')} />
                      : null
                }
              </div>
              <div className='top-mid'>
                <div className='lane-img-cnt'>
                  {
                    props.laneGeometryData.sb_laneconfig.split("").map((item, idx) => {
                      return ((item != 0) ? <div className='remove-img-cnt'><img src={require('../../../assets/icons/lane_config/' + item + '.svg')} /></div> : null)
                    })
                  }
                </div>
              </div>
              <div className='corner-top-right'>
                {
                  props.laneGeometryData.control_type === 'Signal' ?
                    <img src={require('../../../assets/icons/lane_config/signal.svg')} />
                    :
                    props.laneGeometryData.control_type === 'AWSC' || (props.laneGeometryData.control_type === 'TWSC' && props.laneGeometryData.stop_controlled === 'EW') ?
                      <img src={require('../../../assets/icons/lane_config/stop_sign.svg')} />
                      : null
                }
              </div>
            </div>
            <div>
              <div className='mid-left'>
                <div className='lane-img-cnt'>
                  {
                    props.laneGeometryData.eb_laneconfig.split("").map((item, idx) => {
                      return ((item != 0) ? <div className='remove-img-cnt'><img src={require('../../../assets/icons/lane_config/' + item + '.svg')} /></div> : null)
                    })
                  }
                </div>
              </div>
              <div className='mid-mid'>
              </div>
              <div className='mid-right'>
                <div className='lane-img-cnt'>
                  {
                    props.laneGeometryData.wb_laneconfig.split("").map((item, idx) => {
                      return ((item != 0) ? <div className='remove-img-cnt'><img src={require('../../../assets/icons/lane_config/' + item + '.svg')} /></div> : null)
                    })
                  }
                </div>
              </div>
            </div>
            <div>
              <div className='corner-bottom-left'>
                {
                  props.laneGeometryData.control_type === 'Signal' ?
                    <img src={require('../../../assets/icons/lane_config/signal.svg')} />
                    :
                    props.laneGeometryData.control_type === 'AWSC' ||(props.laneGeometryData.control_type === 'TWSC' && props.laneGeometryData.stop_controlled === 'EW') ?
                      <img src={require('../../../assets/icons/lane_config/stop_sign.svg')} />
                      : null
                }
              </div>
              <div className='bottom-mid'>
                <div className='lane-img-cnt'>
                  {
                    props.laneGeometryData.nb_laneconfig.split("").map((item, idx) => {
                      return ((item != 0) ? <div className='remove-img-cnt'><img src={require('../../../assets/icons/lane_config/' + item + '.svg')} /></div> : null)
                    })
                  }
                </div>
              </div>
              <div className='corner-bottom-right'>
                {
                  props.laneGeometryData.control_type === 'Signal' ?
                    <img src={require('../../../assets/icons/lane_config/signal.svg')} />
                    :
                    props.laneGeometryData.control_type === 'AWSC' || (props.laneGeometryData.control_type === 'TWSC' && props.laneGeometryData.stop_controlled === 'NS') ?
                      <img src={require('../../../assets/icons/lane_config/stop_sign.svg')} />
                      : null
                }
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', height: '100%', width: "100%", "align-items": "center", position: "absolute"}}>
            <div style={{display: 'flex', height: '50%', width: "50%", "align-items":"flex-start", "justify-content": "flex-start", transform:"rotate(270deg)"}}>
              <div className='eb-approach' style={{width: "100%", position: "absolute", top: "-8px"}}>
                <span>{props.approaches.eb_approach}</span>
              </div>
            </div>
            <div style={{display: 'flex', height: '50%', width: "50%", "align-items": "flex-start", "justify-content": "flex-start", transform:"rotate(90deg)"}}>
              <div className='wb-approach' style={{width: "100%", position: "absolute", top: "-8px"}}>
                <span>{props.approaches.wb_approach}</span>
              </div>
            </div>
          </div>
        </div>
        <div className='nb-approach' style={{marginTop: '-14px'}}>
          <span>{props.approaches.nb_approach}</span>
        </div>
        </>
        :
          (getPrivileges().length !== 0 && getPrivileges().includes(1)) &&
          <div className='no-lane-geometry-set'>
            <p>This station has no lane geometry or intersection control type data set at this time.</p>
            <Button onClick={handleShowLane} ><img src={require("../../../assets/icons/lane_config/set_lane_icon_btn.png")} /> <label>Set lane geometry</label></Button>
          </div>
      }

      {
        moreOpt &&
        <ClickAwayListener onClickAway={handleClickAway}>
          <div className='set-edit-lane'>
            <div  onClick={handleShowLane}>
              <img src={require("../../../assets/icons/lane_config/set_lane_icon_btn_gray.png")} />
              <label>{props.stationData['FK_lane_config_id'] ? 'Edit ' : 'Set '} lane geometry</label>
            </div>
          </div>
        </ClickAwayListener>
      }
    </Card>
  )
}
export default LaneGeometry;